import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_a5neew5xdy: FaireBrandEntity = {
  token: "b_a5neew5xdy",
  type: "brand",
  name: "Northern Icons Creations INC",
  avatarUrl:
    "https://cdn.faire.com/fastly/56bf34ec9f4274e563395ca263e8e0780b41544c962d4fbcccb80bc4f0ab5829.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/dfef46e01d10ddc9052c809c8284741413b13bf9066599de0efd60a67091156f.png",
  logoUrl:
    "https://cdn.faire.com/fastly/56bf34ec9f4274e563395ca263e8e0780b41544c962d4fbcccb80bc4f0ab5829.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/dfef46e01d10ddc9052c809c8284741413b13bf9066599de0efd60a67091156f.png",
  location: "Vancouver, BC, CAN",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 53,
  isTopShop: true,
  isInsider: false,
  description:
    "Our journey started back in 2002 with a clear vision: crafting top-notch beanie hats in vibrant colors and amusing patterns, all while prioritizing sustainability. so that you can spend more time outside, Since then, our enthusiasm has only grown stronger.\n\nMeticulous attention to every aspect is at the core of our work. We tirelessly strive to create imaginative and groundbreaking products, driven by an unwavering passion and exquisite artistry.\n\nThe most rewarding aspect of our business is witnessing the radiant smile on your face when you wear our products. We take great pride in evoking cherished memories through our everyday items, always placing utmost importance on the finer details.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:13.168Z",
    importedBy: "entity-db-cli",
  },
};
